import React, { createContext, useCallback, useContext, useState } from 'react';
import { useCity } from './CityContext';
import { DEFAULT_EMAIL_IDENTITY } from '../data/emailIdentity';
import type { City } from '../utils/activeCity';
import type { EmailIdentity } from '../types/emailIdentity';
interface EmailIdentityContextValue {
  /** Identity of the city currently administered. */
  identity: EmailIdentity;
  updateIdentity: (patch: Partial<EmailIdentity>) => void;
}
const EmailIdentityContext = createContext<EmailIdentityContextValue>({
  identity: DEFAULT_EMAIL_IDENTITY.Brossard,
  updateIdentity: () => {}
});

/** Email header / footer settings, one set per city. Edited in Configurer → Identité. */
export function EmailIdentityProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const {
    city
  } = useCity();
  const [byCity, setByCity] = useState<Record<City, EmailIdentity>>(DEFAULT_EMAIL_IDENTITY);
  const updateIdentity = useCallback((patch: Partial<EmailIdentity>) => setByCity(prev => ({
    ...prev,
    [city]: {
      ...prev[city],
      ...patch
    }
  })), [city]);
  return <EmailIdentityContext.Provider value={{
    identity: byCity[city],
    updateIdentity
  }} data-id="element-6546" data-mp="csaypfaa03uz">
      {children}
    </EmailIdentityContext.Provider>;
}
export function useEmailIdentity() {
  return useContext(EmailIdentityContext);
}